import { render } from "./CommonButton.vue?vue&type=template&id=05adeda7&scoped=true&ts=true"
import script from "./CommonButton.vue?vue&type=script&lang=ts"
export * from "./CommonButton.vue?vue&type=script&lang=ts"

import "./CommonButton.vue?vue&type=style&index=0&id=05adeda7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05adeda7"]])

export default __exports__